(function () {
  if (customElements.get('bundle-showcase')) return;

  class BundleShowcase extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.imageDuration = (Number(this.dataset.imageDuration) || 5) * 1000;
      this.autoplay = this.dataset.autoplay !== 'false';
      this.tabButtons = Array.from(this.querySelectorAll('[role="tab"]'));
      this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
      this.slides = Array.from(this.querySelectorAll('[data-slide]'));
      this.segs = Array.from(this.querySelectorAll('[data-seg]'));
      this.tablist = this.querySelector('[data-tablist]');
      this.index = 0;
      this.timer = null;
      this.timeRaf = 0;
      this.boundOnEnded = this.onVideoEnded.bind(this);
      this.boundOnTime = this.onVideoTime.bind(this);
      this.boundResize = this.onResize.bind(this);
      this.boundDocClick = this.onDocClick.bind(this);
      this.slideVideos = this.slides.map(function (slide) {
        return slide.querySelector('video');
      });

      this.bindTabs();
      this.bindTabScroll();
      this.bindMedia();
      this.bindCutouts();
      this.bindGifts();
      this.bindCart();
      this.observePlay();
    }

    disconnectedCallback() {
      this.stop();
      this.stopCutouts();
      if (this.io) this.io.disconnect();
      window.removeEventListener('resize', this.boundResize);
      document.removeEventListener('click', this.boundDocClick);
      if (this.timeRaf) cancelAnimationFrame(this.timeRaf);
    }

    bindTabs() {
      this.tabButtons.forEach(function (btn, i) {
        btn.addEventListener('click', function () {
          this.selectTab(i);
        }.bind(this));
        btn.addEventListener('keydown', function (event) {
          if (event.key === 'ArrowRight') this.selectTab((i + 1) % this.tabButtons.length);
          if (event.key === 'ArrowLeft') this.selectTab((i - 1 + this.tabButtons.length) % this.tabButtons.length);
        }.bind(this));
      }, this);
    }

    selectTab(index) {
      this.tabButtons.forEach(function (btn, i) {
        var selected = i === index;
        btn.setAttribute('aria-selected', selected ? 'true' : 'false');
        btn.tabIndex = selected ? 0 : -1;
      });
      this.panels.forEach(function (panel, i) {
        panel.hidden = i !== index;
      });
      this.centerTab(this.tabButtons[index]);
      this.syncCutouts();
    }

    centerTab(active) {
      var list = this.tablist;
      if (!list || !active) return;

      if (active === this.tabButtons[0]) {
        list.scrollTo({ left: 0, behavior: 'smooth' });
        return;
      }

      var listRect = list.getBoundingClientRect();
      var btnRect = active.getBoundingClientRect();
      var buttonCenter = list.scrollLeft + (btnRect.left - listRect.left) + btnRect.width / 2;
      var maxScroll = Math.max(0, list.scrollWidth - list.clientWidth);
      var scrollLeft = Math.max(0, Math.min(buttonCenter - list.clientWidth / 2, maxScroll));

      list.scrollTo({ left: scrollLeft, behavior: 'smooth' });
    }

    bindTabScroll() {
      var list = this.tablist;
      if (!list) return;
      var prev = this.querySelector('[data-tab-prev]');
      var next = this.querySelector('[data-tab-next]');
      var update = function () {
        var overflow = list.scrollWidth > list.clientWidth + 4;
        if (prev) prev.hidden = !overflow;
        if (next) next.hidden = !overflow;
      };
      if (prev) {
        prev.addEventListener('click', function () {
          list.scrollBy({ left: -160, behavior: 'smooth' });
        });
      }
      if (next) {
        next.addEventListener('click', function () {
          list.scrollBy({ left: 160, behavior: 'smooth' });
        });
      }
      this.tabResize = update;
      update();
      window.addEventListener('resize', this.boundResize);
    }

    onResize() {
      if (this.resizeRaf) return;
      this.resizeRaf = requestAnimationFrame(function () {
        this.resizeRaf = 0;
        if (this.tabResize) this.tabResize();
      }.bind(this));
    }

    bindCutouts() {
      this.cutoutState = Array.from(this.querySelectorAll('[data-cutout]')).map(function (root) {
        var state = {
          root: root,
          slides: Array.from(root.querySelectorAll('[data-cutout-slide]')),
          dots: Array.from(root.querySelectorAll('[data-cutout-dot]')),
          index: 0,
          timer: null,
        };
        var prev = root.querySelector('[data-cutout-prev]');
        var next = root.querySelector('[data-cutout-next]');
        if (prev) {
          prev.addEventListener('click', function (event) {
            event.preventDefault();
            event.stopPropagation();
            this.showCutout(state, state.index - 1);
            this.playCutout(state);
          }.bind(this));
        }
        if (next) {
          next.addEventListener('click', function (event) {
            event.preventDefault();
            event.stopPropagation();
            this.showCutout(state, state.index + 1);
            this.playCutout(state);
          }.bind(this));
        }
        state.dots.forEach(function (dot) {
          dot.addEventListener('click', function (event) {
            event.preventDefault();
            event.stopPropagation();
            this.showCutout(state, Number(dot.getAttribute('data-cutout-dot')) || 0);
            this.playCutout(state);
          }.bind(this));
        }, this);
        root.addEventListener('mouseenter', function () {
          this.stopCutout(state);
        }.bind(this));
        root.addEventListener('mouseleave', function () {
          this.playCutout(state);
        }.bind(this));
        return state;
      }, this);
    }

    showCutout(state, next) {
      if (!state.slides.length) return;
      state.index = (next + state.slides.length) % state.slides.length;
      state.slides.forEach(function (slide, i) {
        var active = i === state.index;
        slide.classList.toggle('is-active', active);
        slide.hidden = !active;
      });
      state.dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === state.index);
      });
    }

    isCutoutActive(state) {
      var panel = state.root.closest('[role="tabpanel"]');
      return this.inView && (!panel || !panel.hidden);
    }

    playCutout(state) {
      this.stopCutout(state);
      if (!this.isCutoutActive(state) || state.slides.length < 2) return;
      state.timer = window.setTimeout(function () {
        this.showCutout(state, state.index + 1);
        this.playCutout(state);
      }.bind(this), this.imageDuration);
    }

    stopCutout(state) {
      if (!state.timer) return;
      clearTimeout(state.timer);
      state.timer = null;
    }

    stopCutouts() {
      if (!this.cutoutState) return;
      this.cutoutState.forEach(function (state) {
        this.stopCutout(state);
      }, this);
    }

    syncCutouts() {
      if (!this.cutoutState) return;
      this.cutoutState.forEach(function (state) {
        if (this.isCutoutActive(state)) this.playCutout(state);
        else this.stopCutout(state);
      }, this);
    }

    bindGifts() {
      this.querySelectorAll('[data-gift-trigger]').forEach(function (trigger) {
        var wrap = trigger.closest('.bundle-showcase__gift-media');
        var pop = wrap && wrap.querySelector('[data-gift-pop]');
        if (!pop) return;
        var slides = Array.from(pop.querySelectorAll('[data-gift-slide]'));
        var dots = Array.from(pop.querySelectorAll('[data-gift-dot]'));
        var index = 0;
        var hideTimer = null;

        var showSlide = function (next) {
          if (!slides.length) return;
          index = (next + slides.length) % slides.length;
          slides.forEach(function (slide, i) {
            var active = i === index;
            slide.classList.toggle('is-active', active);
            slide.hidden = !active;
          });
          dots.forEach(function (dot, i) {
            dot.classList.toggle('is-active', i === index);
          });
        };

        var open = function () {
          clearTimeout(hideTimer);
          pop.hidden = false;
          trigger.setAttribute('aria-expanded', 'true');
        };

        var close = function () {
          pop.hidden = true;
          trigger.setAttribute('aria-expanded', 'false');
        };

        var scheduleClose = function () {
          clearTimeout(hideTimer);
          hideTimer = window.setTimeout(close, 160);
        };

        trigger.addEventListener('mouseenter', open);
        trigger.addEventListener('focus', open);
        pop.addEventListener('mouseenter', open);
        trigger.addEventListener('mouseleave', scheduleClose);
        pop.addEventListener('mouseleave', scheduleClose);
        trigger.addEventListener('click', function (event) {
          event.preventDefault();
          if (pop.hidden) open();
          else close();
        });

        var prev = pop.querySelector('[data-gift-prev]');
        var next = pop.querySelector('[data-gift-next]');
        if (prev) {
          prev.addEventListener('click', function (event) {
            event.stopPropagation();
            showSlide(index - 1);
          });
        }
        if (next) {
          next.addEventListener('click', function (event) {
            event.stopPropagation();
            showSlide(index + 1);
          });
        }
        dots.forEach(function (dot) {
          dot.addEventListener('click', function (event) {
            event.stopPropagation();
            showSlide(Number(dot.dataset.giftDot) || 0);
          });
        });
      }, this);
      if (this.querySelector('[data-gift-trigger]')) {
        document.addEventListener('click', this.boundDocClick);
      }
    }

    onDocClick(event) {
      this.querySelectorAll('[data-gift-pop]').forEach(function (pop) {
        var wrap = pop.closest('.bundle-showcase__gift-media');
        if (!wrap || wrap.contains(event.target)) return;
        pop.hidden = true;
        var trigger = wrap.querySelector('[data-gift-trigger]');
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
      });
    }

    bindMedia() {
      var prev = this.querySelector('[data-media-prev]');
      var next = this.querySelector('[data-media-next]');
      if (prev) {
        prev.addEventListener('click', function () {
          this.go(-1);
        }.bind(this));
      }
      if (next) {
        next.addEventListener('click', function () {
          this.go(1);
        }.bind(this));
      }
      this.segs.forEach(function (seg) {
        seg.addEventListener('click', function () {
          this.show(Number(seg.dataset.seg) || 0);
        }.bind(this));
      }, this);

      var media = this.querySelector('[data-media]');
      if (media) {
        media.addEventListener('mouseenter', this.pause.bind(this));
        media.addEventListener('mouseleave', function () {
          if (this.inView && this.autoplay) this.playCurrent();
        }.bind(this));
      }
    }

    observePlay() {
      this.inView = false;
      if (!('IntersectionObserver' in window)) {
        this.inView = true;
        if (this.autoplay) this.show(0);
        this.syncCutouts();
        return;
      }
      this.io = new IntersectionObserver(function (entries) {
        this.inView = entries.some(function (entry) {
          return entry.isIntersecting;
        });
        if (this.inView && this.autoplay) this.show(this.index);
        else this.pause();
        this.syncCutouts();
      }.bind(this), { threshold: 0.35 });
      this.io.observe(this);
    }

    go(step) {
      if (!this.slides.length) return;
      this.show((this.index + step + this.slides.length) % this.slides.length);
    }

    show(index) {
      if (!this.slides.length) return;
      this.stop();
      this.index = index;
      this.slides.forEach(function (slide, i) {
        var active = i === index;
        slide.classList.toggle('is-active', active);
        slide.hidden = !active;
        var video = this.slideVideos[i];
        if (video && !active) {
          video.pause();
          if (video.currentTime) video.currentTime = 0;
        }
      }, this);
      this.segs.forEach(function (seg, i) {
        seg.classList.toggle('is-active', i === index);
        seg.classList.toggle('is-done', i < index);
        var fill = seg.querySelector('.bundle-showcase__seg-fill');
        if (!fill) return;
        fill.style.animation = 'none';
        fill.style.width = i < index ? '100%' : '0';
      });
      if (this.inView && this.autoplay) this.playCurrent();
    }

    playCurrent() {
      var slide = this.slides[this.index];
      if (!slide) return;
      var video = this.slideVideos[this.index];
      var fill = this.segs[this.index] && this.segs[this.index].querySelector('.bundle-showcase__seg-fill');
      if (video) {
        if (video.preload === 'none') video.preload = 'metadata';
        video.removeEventListener('ended', this.boundOnEnded);
        video.removeEventListener('timeupdate', this.boundOnTime);
        video.addEventListener('ended', this.boundOnEnded);
        video.addEventListener('timeupdate', this.boundOnTime);
        var playPromise = video.play();
        if (playPromise && playPromise.catch) playPromise.catch(function () {});
        return;
      }
      var duration = (Number(slide.dataset.duration) || this.imageDuration / 1000) * 1000;
      if (fill) {
        fill.style.width = '0';
        fill.style.animation = 'none';
        void fill.offsetWidth;
        fill.style.animation = 'bundle-showcase-fill ' + duration + 'ms linear forwards';
      }
      this.timer = window.setTimeout(function () {
        this.go(1);
      }.bind(this), duration);
    }

    onVideoTime(event) {
      if (this.timeRaf) return;
      var video = event.currentTarget;
      this.timeRaf = requestAnimationFrame(function () {
        this.timeRaf = 0;
        var fill = this.segs[this.index] && this.segs[this.index].querySelector('.bundle-showcase__seg-fill');
        if (!fill || !video.duration) return;
        fill.style.animation = 'none';
        fill.style.width = Math.min(100, (video.currentTime / video.duration) * 100) + '%';
      }.bind(this));
    }

    onVideoEnded() {
      this.go(1);
    }

    pause() {
      this.stop();
      var video = this.slideVideos[this.index];
      if (video) video.pause();
    }

    stop() {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      if (this.timeRaf) {
        cancelAnimationFrame(this.timeRaf);
        this.timeRaf = 0;
      }
      this.slideVideos.forEach(function (video) {
        if (!video) return;
        video.removeEventListener('ended', this.boundOnEnded);
        video.removeEventListener('timeupdate', this.boundOnTime);
      }, this);
    }

    goToCheckout() {
      var form = document.createElement('form');
      form.method = 'POST';
      form.action = (window.routes && window.routes.cart_url) || '/cart';
      var input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'checkout';
      form.appendChild(input);
      document.body.appendChild(form);
      form.submit();
    }

    prepareCartDrawer() {
      var cartDrawer = document.querySelector('cart-drawer');
      if (!cartDrawer) return Promise.resolve(null);
      var ready = customElements.whenDefined
        ? customElements.whenDefined('cart-drawer')
        : Promise.resolve();
      return ready.then(function () {
        cartDrawer = document.querySelector('cart-drawer');
        if (!cartDrawer) return null;
        if (typeof cartDrawer.init === 'function') cartDrawer.init();
        if (typeof window.loadTemplateContent === 'function') window.loadTemplateContent(cartDrawer);
        return cartDrawer;
      });
    }

    openCartDrawer(cartDrawer) {
      if (!cartDrawer) {
        var bubble = document.getElementById('cart-icon-bubble');
        if (bubble) bubble.click();
        return;
      }
      cartDrawer.classList.remove('is-empty');
      var inner = cartDrawer.querySelector('.drawer__inner');
      if (inner) inner.classList.remove('is-empty');
      if (typeof cartDrawer.open === 'function') cartDrawer.open();
      else {
        cartDrawer.classList.add('animate', 'active');
        document.body.classList.add('overflow-hidden');
      }
    }

    addToCart(variantId, button) {
      var cartNotification = document.querySelector('cart-notification');
      var cartItems = document.querySelector('cart-items');
      button.disabled = true;

      return this.prepareCartDrawer().then(function (cartDrawer) {
        var sections = ['cart-drawer', 'cart-icon-bubble'];
        if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
          sections = cartDrawer.getSectionsToRender().map(function (section) {
            return section.id;
          });
        }
        if (cartNotification && typeof cartNotification.getSectionsToRender === 'function') {
          if (typeof window.loadTemplateContent === 'function') window.loadTemplateContent(cartNotification);
          sections = sections.concat(cartNotification.getSectionsToRender().map(function (section) {
            return section.id;
          }));
        }
        if (cartItems && typeof cartItems.getSectionsToRender === 'function') {
          sections = sections.concat(cartItems.getSectionsToRender().map(function (section) {
            return section.section;
          }));
        }
        sections = sections.filter(Boolean).filter(function (id, index, list) {
          return list.indexOf(id) === index;
        });

        var body = new FormData();
        body.append('id', String(variantId));
        body.append('quantity', '1');
        body.append('sections', sections.join(','));
        body.append('sections_url', window.location.pathname);

        var config = typeof fetchConfig === 'function'
          ? fetchConfig('javascript')
          : { method: 'POST', headers: { Accept: 'application/javascript' } };
        config.headers = config.headers || {};
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        config.body = body;

        return fetch((window.routes && window.routes.cart_add_url) || '/cart/add', config)
          .then(function (res) {
            return res.json();
          })
          .then(function (data) {
            if (data.status) throw new Error(data.description || data.message || 'add failed');
            var atcAction = window.theme && theme.settings && theme.settings.cartDrawer && theme.settings.cartDrawer.atcAction;
            if (atcAction === 'page') {
              window.location = (window.routes && window.routes.cart_url) || '/cart';
              return data;
            }
            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                cartData: data,
                productVariantId: Number(variantId),
              });
            }
            try {
              if (cartDrawer && typeof cartDrawer.renderContents === 'function' && data.sections) {
                cartDrawer.renderContents(data);
              }
            } catch (e) {}
            try {
              if (cartItems && typeof cartItems.renderContents === 'function' && data.sections) {
                cartItems.renderContents(data);
              }
            } catch (e) {}
            this.openCartDrawer(cartDrawer);
            return data;
          }.bind(this));
      }.bind(this)).finally(function () {
        button.disabled = false;
      });
    }

    bindCart() {
      this.addEventListener('click', function (event) {
        var button = event.target.closest('[data-variant-id]');
        if (!button || !this.contains(button)) return;
        var variantId = button.getAttribute('data-variant-id');
        if (!variantId || button.disabled) return;
        var buyNow = button.hasAttribute('data-buy-now');
        if (buyNow) {
          button.disabled = true;
          fetch((window.routes && window.routes.cart_add_url) || '/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: Number(variantId), quantity: 1 }),
          })
            .then(function (res) {
              return res.json().then(function (data) {
                if (!res.ok || data.status) throw new Error(data.description || data.message || 'add failed');
                return data;
              });
            })
            .then(function () {
              this.goToCheckout();
            }.bind(this))
            .catch(function () {})
            .finally(function () {
              button.disabled = false;
            });
          return;
        }
        this.addToCart(variantId, button);
      }.bind(this));
    }
  }

  customElements.define('bundle-showcase', BundleShowcase);
})();
